import { useEffect, useState } from "react";
import { Confetti } from "@/components/Confetti";

const monthKey = () => { const d = new Date(); return `${d.getFullYear()}-${d.getMonth() + 1}`; };

export const BonusSpinBanner = ({ members = [], kt = (s) => s }) => {
  const [burst, setBurst] = useState(null);
  const rows = members.filter((m) => m.bonus_target != null);
  const earned = rows.filter((m) => m.bonus_earned);
  const onTrack = rows.filter((m) => !m.bonus_earned && m.month_earned && m.bonus_needed <= (m.bonus_target - m.month_threshold) / 2);
  const earnedIds = earned.map((m) => m.user_id).join(",");

  useEffect(() => {
    if (!earnedIds) { return; }
    const key = `slackr_bonus_spin_celebrated_${monthKey()}`;
    const seen = new Set((localStorage.getItem(key) || "").split(",").filter(Boolean));
    const fresh = earnedIds.split(",").filter((id) => !seen.has(id));
    if (fresh.length) {
      fresh.forEach((id) => seen.add(id));
      localStorage.setItem(key, [...seen].join(","));
      setBurst(Date.now());
    }
  }, [earnedIds]);

  if (!earned.length && !onTrack.length) return null;
  return (
    <>
      <div className="relative z-[120]"><Confetti burstKey={burst} /></div>
      <div data-testid="kiosk-bonus-spin-banner" className="mx-4 mt-4 rounded-3xl px-6 py-4 flex items-center gap-4 animate-pop text-white"
        style={{ background: "linear-gradient(120deg, #7C3AED, #EC4899)" }}>
        <span className="text-4xl shrink-0 animate-spin" style={{ animationDuration: "4s" }}>🎡</span>
        <div className="min-w-0 space-y-0.5">
          {earned.length > 0 && (
            <p data-testid="kiosk-bonus-spin-earned" className="font-head font-black text-2xl leading-tight">
              {kt("Hoera!")} {earned.map((m) => m.name).join(" & ")} {earned.length > 1 ? kt("verdienen een extra spin!") : kt("verdient een extra spin!")}
            </p>
          )}
          {onTrack.length > 0 && (
            <p data-testid="kiosk-bonus-spin-ontrack" className={`font-head font-bold ${earned.length ? "text-sm opacity-90" : "text-xl"}`}>
              {onTrack.map((m) => `${m.name} (${kt("nog")} ${m.bonus_needed} ${kt("pt")})`).join(" · ")} — {kt("op koers voor een extra spin!")}
            </p>
          )}
          <p className="text-xs opacity-80 font-semibold">{kt("De extra spin wordt op de resetdatum van de maand toegekend.")}</p>
        </div>
      </div>
    </>
  );
};
